module.exports = __webpack_public_path__ + "img/star.e9069ee8.svg";